module.exports = __webpack_public_path__ + "static/media/ajax_loader.a90e737d.gif";